import { render, staticRenderFns } from "./CasinoIntegrationOptionCreate.vue?vue&type=template&id=297680a0&scoped=true&"
import script from "./CasinoIntegrationOptionCreate.vue?vue&type=script&lang=js&"
export * from "./CasinoIntegrationOptionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297680a0",
  null
  
)

export default component.exports